import React from "react";
import { Image } from "antd";
import { imgSrc } from "../../../modules";
import "./mddc.css";

const mddc = ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg", "8.jpg", "9.jpg"];

class MDDCComponent extends React.Component {
    render() {
        return (
            <div id="mddc">
                <div className="container">
                    <h2>เครื่องมือแพทย์</h2>
                    <p>นอกจากการจัดส่งเวชภัณฑ์ และเวชสำอางค์ อาหารเสริมแล้ว เรายังเชี่ยวชาญในการจัดส่งเครื่องมือแพทย์อีกด้วย</p>
                    <div className="gallery">
                        <Image.PreviewGroup>
                            {mddc.map((value, key) => {
                                return (
                                    <div key={"gallery_" + key}>
                                        <Image
                                            key={"team3_" + key}
                                            src={imgSrc(value, false, "mddc")}
                                            alt={value}
                                            preview={{
                                                src: imgSrc(value, false, "mddc"),
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </Image.PreviewGroup>
                    </div>
                </div>
            </div>
        );
    }
}

export default MDDCComponent;
